import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import { useRouter } from 'next/router';
import { useState } from 'react';
import imgLocale1 from './imgs/imgLocale1';
import imgLocale2 from './imgs/imgLocale2';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'mx' } = useRouter();
    const img1 = imgLocale1[locale] || imgLocale1.us;
    const img2 = imgLocale2[locale] || imgLocale2.us;

    const listTabH: EfTabItemProps[] = [
        { type: 'a1', title: t('J_item1_tab') },
        { type: 'a2', title: t('J_item2_tab') },
    ];

    const tabObj: any = {
        a1: {
            title: t('J_item1_title'),
            desc: t('J_item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1775285218098/9-pc-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1775285218469/9-m-1.jpg',
        },
        a2: {
            title: t('J_item2_title'),
            desc: t('J_item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1775285217912/9-pc-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1775285218285/9-m-2.jpg',
        },
    };

    const [activeType, setActiveType] = useState('a1');

    const activeTypeCallback = (item: EfTabItemProps) => {
        setActiveType(item.type);
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section range7`} data-section-id="D3-J" id='D3-J'>
            <EfSpec className="spec-x" />
            <EfSection label={t('J_label')} title={t('J_title')} desc={t('J_desc')} theme="black" />
            <ul className="boxes">
                {listTabH?.map((item: any, k: number) => (
                    <li className={`box${`a${k + 1}` === activeType ? ' active' : ''}`} key={k}>
                        <div className="box-img">
                            <EfImg pc={tabObj[`a${k + 1}`].pc} pad={tabObj[`a${k + 1}`].h5} h5={tabObj[`a${k + 1}`].h5} />
                        </div>
                        <div className="box-msg">
                            <div className="box-title">{tabObj[`a${k + 1}`].title}</div>
                            <div className="box-desc">{tabObj[`a${k + 1}`].desc}</div>
                        </div>
                    </li>
                ))}
            </ul>
            <EfTab list_name={t('J_title')} items={listTabH} activeType={activeType} onChange={activeTypeCallback} theme="white" />
        </div>
    );
}
